var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bigScreen-wrap"},[_vm._v("bigScreen页面")])
}
var staticRenderFns = []

export { render, staticRenderFns }